import React, {useEffect, useState} from 'react';
import {useNavigate} from "react-router-dom";
import {useDispatch} from "react-redux";
import {
    AuthInput,
    AuthLabel,
    FormDiv,
    InputDiv,
    LogoDiv,
    MessageSpan,
    ShowPassword,
    SubmitButton,
    SubmitDiv,
    Wrapper
} from "./authPageStyles";
import {getAuthentication, setEmail, setPassword} from "store/reducers/AuthSlice";
import {LogoMainIcon} from "../../assets/images";
import {useAppSelector} from "../../hooks/redux";

const AuthPage = () => {
    const navigate = useNavigate()
    const {password, email, loggedIn, loading} = useAppSelector(state => state.auth)

    const [inputType, setInputType] = useState('password')
    const dispatch = useDispatch()
    useEffect(() => {
        if (loggedIn) {
            navigate('/quotes')
        }
    }, [loggedIn])
    const handleShowPasswordDown = () => {
        setInputType('text')
    }
    const handleShowPasswordLeave = () => {
        setInputType('password')
    }
    const handleShowPasswordUp = () => {
        setInputType('password')
    }
    const handleLoginClick = () => {
        // return Promise
        //     .resolve()
        //     .then(() => dispatch(getAuthentication()))
        // // .then(() => navigate('/quotes'))
        dispatch(getAuthentication())
    }

    return (
        <>
            <Wrapper>
                <LogoDiv>
                    <LogoMainIcon/>
                </LogoDiv>
                <FormDiv>
                    <InputDiv>
                        <AuthLabel>Введите Email</AuthLabel>
                        <AuthInput
                            type={"email"} value={email}
                            onChange={(e) => dispatch(setEmail(e.target.value))}
                        />
                    </InputDiv>
                    <InputDiv>
                        <AuthLabel>Введите пароль</AuthLabel>
                        <AuthInput
                            type={inputType} value={password}
                            onChange={(e) => dispatch(setPassword(e.target.value))}
                        />
                        <ShowPassword
                            onMouseDown={handleShowPasswordDown}
                            onMouseUp={handleShowPasswordUp}
                            onMouseLeave={handleShowPasswordLeave}/>
                        <MessageSpan>Минимум 8 знаков</MessageSpan>
                    </InputDiv>
                    <SubmitDiv>
                        <SubmitButton onClick={handleLoginClick} disabled={loading}>Войти</SubmitButton>
                    </SubmitDiv>
                </FormDiv>
            </Wrapper>

        </>
    );
};

export default AuthPage;
